import React from "react";
import ServicesCard from "./ServicesCard";

const MyServices = () => {
  const services = [
    {
      _id: 1,
      title: "Web Development",
      description:
        "Building and maintaining websites, web applications, and online platforms using programming languages, UI design, and optimization for different devices.",
    },
    {
      _id: 2,
      title: "API Development and Integration",
      description:
        " Our service involves the creation and implementation of APIs to manage categories, streamlining your workflow and facilitating efficient data communication.",
    },
    {
      _id: 3,
      title: "Error fixing",
      description:
        " Identifying and fixing software errors caused by incorrect coding, server issues, or bugs in the system",
    },
    {
      _id: 4,
      title: "WordPress customization",
      description:
        "Customizing WordPress websites by adding features, modifying layout, design, and integrating plugins and widgets to suit specific needs.",
    },
  ];
  return (
    <div className="min-h-screen w-full ">
      <div className=" px-10 py-20">
        <div className="  " data-aos="zoom-in" data-aos-duration="1500">
          <h1 className="text-5xl text-white font-extrabold uppercase mb-20">
            What
            <span className="text-primary"> I Do?</span>
          </h1>

          {/* about me intro content */}

          <div className="grid  lg:grid-cols-2 gap-5">
            {services.map(({ _id, title, description }) => (
              <ServicesCard key={_id} title={title} description={description} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyServices;
